module.exports = __webpack_public_path__ + "img/landing_logo.83cccc16.png";